import { EMP_LIST } from "./ActionType";

const initialValue={
    emplists: [],
    }

    export const dailyUpdateApprovalReducer=(store=initialValue, {type,payload})=>{

        if(type===EMP_LIST){
            return {
                ...store,emplists:  payload.userList || [], 
            };
        }
        
       return store
    }